import { useSelector } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { createCardPaymentRequest } from "../../services/paymentService";

export function DebugToolCardPaymentSnippet() {
    const totalAmount: number = useSelector((state:AppState) => state.cart.totalAmount);

    function onShow() {
        const req = createCardPaymentRequest(totalAmount, uuidv4())
        return JSON.stringify(req, null, 1);
    }
    return (
        <div className="snippet-container">
            <pre>
                { onShow() }
            </pre>
        </div>
    )
}